import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";
import { GridToolbarColumnsButton, GridToolbarContainer, GridToolbarExport } from "@material-ui/data-grid";

import { useCampaignDashboardStyles } from "../../CampaignDashboardStylesContext";

const LineItemsReportDashboardToolbar: FC = () => {
  const classes = useCampaignDashboardStyles();
  return (
    <GridToolbarContainer className={classes.toolbar}>
      <Typography variant="h3">Campaign Metrics</Typography>

      <div className={classes.toolbarControls}>
        <GridToolbarColumnsButton className={classes.selectMetricsBtn} startIcon={null} />
        <GridToolbarExport className={classes.exportButton} />
      </div>
    </GridToolbarContainer>
  );
};

export default LineItemsReportDashboardToolbar;
